export const environment = {
  production: true,
  encrypt:true,
  api: 'https://apidma.loyaltysp.es',
  apikey: 'z4jE1EZRSsUgGRgYt4N8sUNbtv9qXrpy',
  keyEncrypt:'e61d729f6a2026ec54fb491c1a865dd619210399054006f60444b3cfe1f210f5',
  keycloakUrl: 'https://kcdm2.loyaltysp.es/',
  keycloakRealm: 'DMA_JBt8cDNR2',
  keycloakClientId: 'donor',
  client: 'front-donor',
  minRations: 10,
  maxRations: 100
};


 
